import { Navigate, RouteObject, useLocation } from 'react-router';

export interface LegacyRoute {
  LEGACY_PATH: string;
  RELEVANT_PATH: string;
}

const LegacyRedirect: React.FC<{ legacyRoute: LegacyRoute }> = ({ legacyRoute }) => {
  const { search } = useLocation();
  return <Navigate to={legacyRoute.RELEVANT_PATH} replace state={{ search }} />;
};
export const createLegacyRedirectRoutes = (legacyRoutesConfig: LegacyRoute[]): RouteObject[] => {
  return legacyRoutesConfig.map((legacyRoute) => ({
    path: legacyRoute.LEGACY_PATH,
    element: <LegacyRedirect legacyRoute={legacyRoute} />,
  }));
};
